<template lang="pug">
div(class="tw-relative k-gallery-thumbnail " @mouseover="hover = true" @mouseleave="hover = false")
        div(v-if="hover" class="k-gallery-thumbnail tw-bg-black tw-bg-opacity-50 tw-absolute  tw-z-10 ")
        div(v-if="hover" class="k-gallery-thumbnail tw-absolute tw-z-20 ")
            v-row(no-gutters  class=" fill-height justify-end")
                v-col(cols="auto" align-self="start" class=" ")
                    v-btn( icon plain tile width="30"  height="20" :ripple="false"  @click="remove(item.id)"  )
                        v-icon( class="pr-1 pt-1 tw-text-red-darken-1" color="") mdi-delete-forever
        img( :src="path(item.path)"  class=" k-gallery-thumbnail tw-object-cover tw-absolute  tw-z-0 "  )
</template>
<script>
    export default {
        props:{
            item: {
                type: Object,
                default: null
            }
        },
        data() {
            return{
                hover: false
            }     
        },
        methods: {

            remove(item){
                this.$store.dispatch('galleries/deleteImage', item)
            }
        },
    }
</script>
<style lang="css">
@media only screen and (max-width: 1534px) {
    .k-gallery-thumbnail{
        width: 115px;
        height: 115px
    }
}

@media only screen and (min-width: 1535px) {
    .k-gallery-thumbnail{
        width: 120px;
        height: 120px
    }
}

@media only screen and (min-width: 1536px) {
    .k-gallery-thumbnail{
        width: 180px;
        height: 180px
    }
}

</style>